import { useInstanceCallback } from '@/scenarios/legacy-player/hooks/useInstanceCallback';

import { PlayingState } from '../types/instance';

export const useTogglePlay = (): {
    play: () => void;
    pause: () => void;
    togglePlay: () => PlayingState.play | PlayingState.pause | undefined;
} => {
    const play = useInstanceCallback((instance) => {
        instance?.play();
    });
    const pause = useInstanceCallback((instance) => {
        instance?.pause();
    });

    const togglePlay = useInstanceCallback((instance) => {
        const playingState = instance?.playingState;

        if (!instance || !playingState) {
            return;
        }

        if ([PlayingState.buffering, PlayingState.play].includes(playingState)) {
            pause();
            // eslint-disable-next-line consistent-return
            return PlayingState.pause;
        }

        if ([PlayingState.end, PlayingState.pause].includes(playingState)) {
            play();
            // eslint-disable-next-line consistent-return
            return PlayingState.play;
        }
    });

    return { togglePlay, play, pause };
};
